import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack, Typography } from '@mui/material'
import BoltIcon from '@mui/icons-material/Bolt'
import T from 'prop-types'
import { useNavigate, useParams } from 'react-router-dom'

import SessionsSelect from 'components/atoms/SessionsSelect'
import IconButton from 'components/atoms/IconButton'

export default function PageSessionSelection({
  statusLabel,
  selectLabel,
  task,
  session,
  sessionsList,
  currentActiveSession,
  handleStepUrl = () => {},
  readOnly,
}) {
  const { t } = useTranslation()

  const { step } = useParams()
  const navigate = useNavigate()

  const handleSessionChange = (event) => {
    navigate(handleStepUrl(event.target.value, step))
  }

  const handleBoltClick = () => {
    currentActiveSession &&
      navigate(handleStepUrl(currentActiveSession.sessionId, step))
  }

  return (
    <Stack flexDirection="row" alignItems="center">
      <Box sx={{ height: 1 }}>
        <Typography variant="body2" color="textSecondary">
          <strong>{statusLabel || t('common.form.status')}</strong>
        </Typography>
        <Typography
          variant="body2"
          color={session.agenda[task].state === 'open' ? 'primary' : 'error'}
        >
          <strong>
            {t(`sessions.state.${task}.${session.agenda[task].state}`)}
          </strong>
        </Typography>
      </Box>
      <Box pr={2} />
      <SessionsSelect
        label={selectLabel}
        value={session.sessionId}
        sessions={sessionsList}
        handleSessionChange={handleSessionChange}
        readOnly={readOnly}
      />
      <Box pr={2} />
      <IconButton onClick={handleBoltClick}>
        <BoltIcon color="primary" />
      </IconButton>
    </Stack>
  )
}

PageSessionSelection.propTypes = {
  statusLabel: T.string,
  selectLabel: T.string,
  task: T.string,
  session: T.object.isRequired,
  sessionsList: T.array,
  currentActiveSession: T.object,
  handleStepUrl: T.func,
  readOnly: T.bool,
}
